import { Box, Typography } from '@mui/material'
import ProgramSkillCard from './ProgramSkillCard'
import { sectionHeadingSx } from '../../theme/mobileLayout'

function SkillRow({ skills: rowSkills }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: '1fr 1fr',
          lg: 'repeat(3, 1fr)',
        },
        gap: '40px',
      }}
    >
      {rowSkills.map((skill) => (
        <ProgramSkillCard key={skill.title} {...skill} />
      ))}
    </Box>
  )
}

export default function ProgramSkillsSection({ title, skills = [], layout = 'grid' }) {
  const isThreeTwo = layout === 'three-two'
  const isSixGrid = layout === 'grid' && skills.length === 6

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 5, md: '80px' }, width: '100%' }}>
      <Typography
        component="h2"
        sx={sectionHeadingSx}
      >
        {title}
      </Typography>

      {isThreeTwo ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '40px', width: '100%' }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
                lg: 'repeat(3, 1fr)',
              },
              gap: '40px',
            }}
          >
            {skills.slice(0, 3).map((skill) => (
              <ProgramSkillCard key={skill.title} {...skill} />
            ))}
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: '1fr 1fr',
              },
              gap: '40px',
            }}
          >
            {skills.slice(3).map((skill) => (
              <ProgramSkillCard key={skill.title} {...skill} />
            ))}
          </Box>
        </Box>
      ) : isSixGrid ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '40px', width: '100%' }}>
          <SkillRow skills={skills.slice(0, 3)} />
          <SkillRow skills={skills.slice(3)} />
        </Box>
      ) : (
        <SkillRow skills={skills} />
      )}
    </Box>
  )
}
